import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useDocumentTitle } from 'rooks';

type PageProps = {
  titleKey: string;
};

export function Page({ titleKey, children }: PropsWithChildren<PageProps>) {
  const { t } = useTranslation('common', { keyPrefix: 'pageTitles' });
  useDocumentTitle(t(titleKey));
  return <>{children}</>;
}
